import React, { useCallback, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";

import { Loader } from "../../common/loader";
import AlertDialog from "../../common/AlertDialog";
import { PER_PAGE, userTimeZone } from "../../helpers/constants";
import SettingsIconSVG from "../../common/customSVGs/SettingsIconSVG";
import TableHeaderForSorting from "../../common/TableHeaderForSorting";
import { getLocalFormatedDate, getObjLength } from "../../helpers/utils";
import CustomPagination from "../../common/customDesignedComponents/CustomPagination";
import { propertyRiskManagementAction } from "../../../redux/slices/admin/property-risk-management/propertyRiskManagementSlice";

const columns = [
  {
    key: 1,
    id: "no.",
    disablePadding: true,
    label: "No.",
  },
  {
    key: 2,
    id: "address",
    disablePadding: true,
    label: "Address",
    minWidth: 190,
  },
  {
    key: 3,
    id: "city",
    disablePadding: true,
    label: "City",
  },
  {
    key: 4,
    id: "state",
    disablePadding: true,
    label: "State",
    value: "state",
  },
  { key: 5, id: "email", disablePadding: true, label: "Email", minWidth: 220 },
  {
    key: 6,
    id: "old_owner",
    disablePadding: true,
    label: "Old Owner",
    minWidth: 130,
  },
  {
    key: 7,
    id: "new_owner",
    disablePadding: true,
    label: "New Owner",
    minWidth: 130,
  },
  {
    key: 8,
    id: "created_at",
    disablePadding: true,
    label: "Created",
    width: 119,
    //  sorting: true,
    //defaultValue: "desc",
  },
  {
    key: 9,
    id: "actions",
    disablePadding: true,
    label: "Actions",
  },
];

function Row({ row, handleMenuClick, page, index, handleCollapsibleRow }) {
  return (
    <React.Fragment>
      <TableRow
        hover
        tabIndex={-1}
        key={(page - 1) * 10 + index + 1}
        onClick={() => handleCollapsibleRow(row)}
        className="cursor-pointer"
        // sx={{ backgroundColor: isCollapsible ? "rgba(3, 149, 255, 0.07)" : "" }}
      >
        <TableCell align="left">{(page - 1) * 10 + index + 1}</TableCell>
        <TableCell align="left">{row?.report?.address || "-"}</TableCell>
        <TableCell align="left">{row?.report?.city || "-"}</TableCell>
        <TableCell align="left" className="text-uppercase">
          {row?.report?.state || "-"}
        </TableCell>
        <TableCell align="left" sx={{ wordBreak: "break-word" }}>
          {row?.report?.email || "-"}
        </TableCell>
        <TableCell align="left">{row?.old_owner_name || "-"}</TableCell>
        <TableCell align="left">{row?.new_owner_name || "-"}</TableCell>
        <TableCell align="left">
          {row?.created_at ? getLocalFormatedDate(row?.created_at) : "-"}
        </TableCell>
        <TableCell align="left">
          <Stack direction="row" spacing={1}>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClick(e, row);
              }}
              size="small"
              className="settings-button"
              aria-haspopup="true"
            >
              <SettingsIconSVG />
            </IconButton>
          </Stack>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const AdminPropertyTransferedListTable = ({
  setPropertiesIDList = () => {},
  propertiesIDList,
  setCSV_Payload = () => {},
}) => {
  const dispatch = useDispatch();

  // states
  const [page, setPage] = useState(1);
  const [isCollapsibleRow, setIsCallapsibleRow] = useState(false);
  const [selectedCollapsibleRow, setSelectedCollapsibleRow] = useState(null);
  const [payload, setPayload] = useState({});
  const [directionFlow, setDirectionFlow] = useState(true);
  const [selectedColumn, setSelectedColumn] = useState(8); // updated_at key for sorting
  const [selectedRow, setSelectedRow] = useState(null);
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);

  // store data
  const {
    monitoredPropertyListLoader,
    riskManagementLoader,
    transferedPropertiesList,
    transferedPropertyActionData,
  } = useSelector((state) => state?.propertyRiskManagement);
  console.log(
    "transferedPropertyActionData==>",
    getObjLength(transferedPropertyActionData)
  );

  const _DATA = transferedPropertiesList?.data
    ? transferedPropertiesList?.data
    : [];
  const count = Math.ceil(transferedPropertiesList?.count / PER_PAGE);

  const handleMenuClick = (event, data) => {
    setPropertiesIDList([]);
    setSelectedRow(data);
    setIsActionModalOpen(event.currentTarget);
  };

  // handle page change
  const handlePageChange = (e, p) => {
    setPropertiesIDList([]);
    setPage(p);
    setPayload((prevState) => ({ ...prevState, offset: (p - 1) * PER_PAGE }));
  };

  //collapsible row
  const handleCollapsibleRow = (row) => {
    if (selectedCollapsibleRow?.id === row?.id && isCollapsibleRow) {
      setIsCallapsibleRow(false);
      return;
    }
    setIsCallapsibleRow(true);
    setSelectedCollapsibleRow(row);
  };

  // for sorting
  const handleSorting = (column) => {
    setDirectionFlow(!directionFlow);
    console.log(column, "Sorting function called", payload);
    console.log("Sorting flow", directionFlow);
    setPayload((prevState) => ({
      ...prevState,
      order_by_column: column,
      sorting_order: !directionFlow ? "desc" : "asc",
    }));
  };

  const handleActionRequest = (action) => {
    dispatch(
      propertyRiskManagementAction?.getTransferedPropertyActionData({
        url: `admin/property-transfers/${selectedRow?.id}/action`,
        data: { action },
        token: true,
      })
    );
    setIsActionModalOpen(false);
  };

  //   get transfered property details
  const getTransferedPropertiesList = useCallback(() => {
    let data = {
      limit: PER_PAGE,
      offset: payload?.offset || 0,
      user_timezone: userTimeZone,
    };
    setCSV_Payload(data);
    dispatch(
      propertyRiskManagementAction?.getTransferedPropertiesList({
        url: `admin/property-transfers`,
        data,
        token: true,
      })
    );
  }, [dispatch, payload?.offset]);

  useEffect(() => {
    getTransferedPropertiesList();
  }, [getTransferedPropertiesList]);

  return (
    <>
      {transferedPropertiesList?.success ? (
        <>
          {/* Listing Table */}
          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <TableContainer>
                <Table
                  sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <TableHeaderForSorting
                    columns={columns}
                    handleSorting={handleSorting}
                    directionFlow={directionFlow}
                    setSelectedColumn={setSelectedColumn}
                    selectedColumn={selectedColumn}
                    numSelected={propertiesIDList?.length}
                    rowCount={_DATA?.length}
                  />
                  <TableBody checkboxSelection>
                    {_DATA?.map((row, index) => {
                      return (
                        <Row
                          row={row}
                          handleMenuClick={handleMenuClick}
                          page={page}
                          index={index}
                          handleCollapsibleRow={handleCollapsibleRow}
                        />
                      );
                    })}
                  </TableBody>
                </Table>
                {!transferedPropertiesList?.data?.length > 0 &&
                  !monitoredPropertyListLoader && (
                    <Typography className="p-5 text-center" variant="h6">
                      No Data Found.
                    </Typography>
                  )}
              </TableContainer>
            </Paper>
            {transferedPropertiesList?.count > PER_PAGE && (
              <Box id="pagination-container">
                <CustomPagination
                  count={count}
                  page={page}
                  handlePageChange={handlePageChange}
                />
              </Box>
            )}
          </Box>
        </>
      ) : (
        <>
          <Typography className="text-center text-danger">
            {transferedPropertiesList?.data?.message}
          </Typography>
        </>
      )}

      {/* Cancel Request Waring popup */}
      {isActionModalOpen && (
        <AlertDialog
          openPopup={isActionModalOpen}
          type={"Warning"}
          title="Ownership Transfer Verification"
          onClose={true}
          onCloseFun={() => {
            setIsActionModalOpen(false);
          }}
          buttons={
            <>
              <div className="text-center stepBtn mt-4 ">
                <Button
                  onClick={() => handleActionRequest("no_action")}
                  className="popup_Btn error_popup_btn mx-1 mb-2 mb-sm-0"
                  variant="contained"
                >
                  No Action Needed
                </Button>
                <Button
                  onClick={() => handleActionRequest("confirmed")}
                  className="popup_Btn success_popup_btn mx-1 mb-2 mb-sm-0"
                  variant="contained"
                >
                  Confirmed
                </Button>
              </div>
            </>
          }
          mesage={
            <>
              Please confirm: Has the ownership of{" "}
              <b>{selectedRow?.report?.address}</b> been officially transferred
              to the new owner?
            </>
          }
          loader={monitoredPropertyListLoader}
          footer={false}
        />
      )}
      {getObjLength(transferedPropertyActionData) ? (
        <AlertDialog
          type={transferedPropertyActionData?.success ? "Success" : "Error"}
          openPopup={true}
          onClose={true}
          onCloseFun={() => {
            if (transferedPropertyActionData?.success) {
              setSelectedRow(null);
              setIsActionModalOpen(false);
              getTransferedPropertiesList();
            }
            dispatch(
              propertyRiskManagementAction?.fetchTransferedPropertyActionData(
                {}
              )
            );
          }}
          mesage={
            transferedPropertyActionData?.success
              ? transferedPropertyActionData?.message
              : transferedPropertyActionData?.data?.message
          }
          footer={false}
        />
      ) : null}

      <Loader open={monitoredPropertyListLoader || riskManagementLoader} />
    </>
  );
};

export default AdminPropertyTransferedListTable;
